document.addEventListener("DOMContentLoaded", function () {
  const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
  productForms.forEach((form) => {
    const formId = form.id;
    const quantityInputs = document.querySelectorAll(
      `input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`,
    );
    if (quantityInputs.length === 0) return;
    form.addEventListener("submit", function (e) {
      const activeQuantityInput = quantityInputs[0];
      const quantity = parseInt(activeQuantityInput.value) || 1;
      form.querySelectorAll('input[type="hidden"][name="quantity"]').forEach((input) => {
        input.remove();
      });
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = quantity;
      form.appendChild(qtyInput);
    });
  });

  function handleResponsiveProductTitles() {
    const productTitles = document.querySelectorAll(".shop-product-title[data-font-size][data-mobile-font-size]");

    function adjustAllTitles() {
      const isMobile = window.innerWidth <= 767;
      productTitles.forEach((title) => {
        const size = isMobile ? title.getAttribute("data-mobile-font-size") : title.getAttribute("data-font-size");
        title.style.setProperty("font-size", `${size}px`, "important");
      });
    }

    // Un seul listener pour tous les titres
    adjustAllTitles();

    if (!window.titleResizeHandlerAdded) {
      window.addEventListener("resize", adjustAllTitles);
      window.titleResizeHandlerAdded = true;
    }
  }
  handleResponsiveProductTitles();
  function initFaqAccordions() {
    const faqContainers = document.querySelectorAll(".product-faq");
    faqContainers.forEach((faqContainer) => {
      const faqId = faqContainer.id;
      if (!faqId) return;
      const faqItems = faqContainer.querySelectorAll(".faq-item");
      const innerFaqContainer = faqContainer.querySelector(".faq-container");
      const isAccordion = innerFaqContainer && innerFaqContainer.getAttribute("data-accordion") === "true";
      faqItems.forEach((item) => {
        const question = item.querySelector(".faq-question");
        if (!question) return;
        if (!question.hasAttribute("data-click-listener-added")) {
          question.setAttribute("data-click-listener-added", "true");
          question.addEventListener("click", () => {
            const isActive = item.classList.contains("active");
            if (isAccordion && !isActive) {
              faqItems.forEach((otherItem) => {
                otherItem.classList.remove("active");
              });
            }
            item.classList.toggle("active");
          });
        }
      });
    });
  }
  initFaqAccordions();
  const readMoreLinks = document.querySelectorAll(".shop-read-more");
  const readLessLinks = document.querySelectorAll(".shop-read-less");
  readMoreLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.closest(".shop-product-description");
      parent.querySelector(".shop-truncated-description").style.display = "none";
      parent.querySelector(".shop-full-description").style.display = "block";
    });
  });
  readLessLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.closest(".shop-product-description");
      parent.querySelector(".shop-truncated-description").style.display = "block";
      parent.querySelector(".shop-full-description").style.display = "none";
    });
  });
});


/* ========== LOOP WIDGET FIX ========== */
(function(){
  var origIcon='';
  function capIcon(){var b=document.querySelector('.shop-add-to-cart-button');if(b){var i=b.querySelector('.button-icon');if(i&&i.querySelector('svg'))origIcon=i.innerHTML;}}
  capIcon();
  function fixBtn(){var b=document.querySelector('.shop-add-to-cart-button');if(!b)return;if(!origIcon)capIcon();var i=b.querySelector('.button-icon');if(i&&!i.querySelector('svg')&&origIcon)i.innerHTML=origIcon;if(!b.querySelector('.button-text')){var t=b.getAttribute('data-persistent-text')||b.getAttribute('data-original-text')||'Add to cart';b.innerHTML='';if(origIcon){var ni=document.createElement('span');ni.className='button-icon';ni.innerHTML=origIcon;b.appendChild(ni);}var nt=document.createElement('span');nt.className='button-text';nt.textContent=t;b.appendChild(nt);}}
  function showDesc(){document.querySelectorAll('[id^="loop-widget-spg-container-id-"]').forEach(function(e){e.classList.remove('loop-display-none');});document.querySelectorAll('.loop-w-checkbox-description-container').forEach(function(e){e.classList.remove('loop-display-none');});}
  function run(){fixBtn();showDesc();}
  setTimeout(run,500);setTimeout(run,1000);setTimeout(run,2000);setTimeout(run,3500);setTimeout(run,5000);
  function watchWidget(){var w=document.querySelector('[id^="loop-widget-container-id-"]');if(!w){setTimeout(watchWidget,500);return;}new MutationObserver(function(){setTimeout(run,100);}).observe(w,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});}
  watchWidget();
  function watchBtn(){var b=document.querySelector('.shop-add-to-cart-button');if(!b){setTimeout(watchBtn,500);return;}new MutationObserver(function(){setTimeout(fixBtn,50);}).observe(b,{childList:true,subtree:true,characterData:true});}
  watchBtn();
})();
/* ========== END LOOP WIDGET FIX ========== */
